import React, { useState } from 'react'
import { getCcChart } from 'src/services/api/charts'
import { Props } from './types'
import { Chart } from '../components/chart'
import { utilData } from '../components/util-data'

const chartData = {
  chart: {
    type: 'variablepie'
  },
  title: {
    text: 'Centros de Custo'
  },
  tooltip: {
    headerFormat: '',
    pointFormat:
      '<span style="color:{point.color}">\u25CF</span> <b> {point.name}</b><br/>' +
      'Valor R$: <b>{point.y:.2f}</b><br/>' +
      'Percentual: <b>{point.z}</b>'
  },
  plotOptions: {
    series: {
      allowPointSelect: true,
      cursor: 'pointer'
    }
  },
  series: [
    {
      name: 'Centro de custo',
      colorByPoint: true,
      borderRadius: 5,
      data: [0],
      minPointSize: 10,
      innerSize: '20%',
      zMin: 0
    }
  ]
}

function updateChatData(data: any) {
  return {
    ...chartData,
    series: [
      {
        name: 'Centro de custo',
        colorByPoint: true,
        borderRadius: 5,
        data,
        minPointSize: 10,
        innerSize: '20%',
        zMin: 0
      }
    ]
  }
}

export default function CcChart({ organization_id }: Props) {
  const [isLoading, setIsLoading] = useState(false)

  async function updateChart(monthFilter: string) {
    if (!monthFilter) {
      return chartData
    }

    setIsLoading(true)
    const date_end = utilData(monthFilter)
    const response = await getCcChart(organization_id, monthFilter, date_end)

    setIsLoading(false)
    if (response.status !== 200) {
      return updateChatData([])
    }

    return updateChatData(response.data.data)
  }

  return <Chart updateChart={updateChart} isLoading={isLoading} />
}
